export interface IFilterOption {
    title: string;
    value: number | string;
}

export const STORY_OCCASIONS: IFilterOption[] = [
    { title: 'Birthday Gift', value: 1 },
    { title: 'Christmas Gift', value: 2 },
    { title: 'Father’s Day Gift', value: 3 },
    { title: 'Graduation Gift', value: 4 },
    { title: 'Mother’s Day Gift', value: 5 },
    { title: 'Wedding Gift', value: 6 },
    { title: 'Back To College Gift', value: 7 },
    { title: 'Passing of pet', value: 8 },
    { title: 'Other', value: 9 },
    { title: 'Valentines day Gift', value: 10 },
    { title: 'Anniversary Gift', value: 11 },
    { title: 'Graduation Gift', value: 12 },
    { title: 'Pride Month Gift', value: 13 },
    { title: 'Easter Gift', value: 14 },
    { title: 'Memorial Day Gift', value: 15 },
    { title: '4th Of July Gift', value: 16 },
    { title: 'Halloween Gift', value: 17 },
    { title: 'Thanksgiving Gift', value: 18 },
    { title: 'New Year’s Gift', value: 19 },
    { title: 'Baby Shower Gift', value: 20 },
    { title: 'Housewarming Gift', value: 21 },
    { title: 'Retirement Gift', value: 22 },
    { title: 'Engagement Gift', value: 23 },
    { title: 'Promotion Gift', value: 24 },
    { title: 'Back To School Gift', value: 25 },
    { title: 'Sports Achievements Gift', value: 26 },
    { title: 'Memorial Gift', value: 27 },
];

export const STORY_RECIPIENTS: IFilterOption[] = [
    { title: 'Prefer not to answer', value: 1 },
    { title: 'Son', value: 2 },
    { title: 'Daughter', value: 3 },
    { title: 'Parent', value: 4 },
    { title: 'Friend', value: 5 },
    { title: 'Co-Worker', value: 6 },
    { title: 'Grandparent', value: 7 },
    { title: 'Myself', value: 8 },
    { title: 'Spouse', value: 9 },
    { title: 'Boyfriend/Girlfriend', value: 10 },
    { title: 'Child', value: 11 },
    { title: 'Other', value: 12 },
];

export const STORY_PRODUCTS: IFilterOption[] = [
    { title: 'Small', value: 1 },
    { title: 'Medium', value: 2 },
    { title: 'Large', value: 3 },
    { title: 'Mini', value: 7 },
    { title: 'Keychain', value: 4 },
    { title: 'Square', value: '5,6,10' },
    { title: 'Extra Large', value: 11 },
];

export const PER_PAGE_OPTIONS = [12, 24, 48];
export const DEFAULT_PER_PAGE = 24;

/** Filters that are always applied on the viewer page and never shown in the UI. */
export const HIDDEN_STORY_FILTERS = {
    isPublished: '1', // Published = yes
    statusId: 3,      // Status = approved
};
